
export const testAction = () => dispatch => {

    // Dispatch Result
    dispatch({
        type: 'TEST_ACTION',
        payload: {
            name: "Test Action",
            items: ['one','two','three']
        }
    })

}
